import { IDebugState } from './types';
import ActionTypes from '../../../constants/ActionTypes';

const initialState: IDebugState = {
  data: {
    bff: {
      branch: '',
      deployedAt: '',
      other: [],
      sso: [],
      logs: [],
    },
    om: {
      branch: '',
      deployedAt: '',
      wsa: [],
      css: [],
      other: [],
      logs: [],
    },
    pc: {
      branch: '',
      deployedAt: '',
      logs: [],
      other: [],
    },
    mockResponse: false,
  },
};

const debugReducer = (state = initialState, action: any): IDebugState => {
  switch (action.type) {
  case ActionTypes.DEBUG.SET_DEBUG_INFO:
    return {
      ...state,
      data: action.payload,
    };
  case ActionTypes.DEBUG.SET_MOCK_RESPONSE:
    return {
      ...state,
      data: {
        ...state.data,
        mockResponse: action.payload,
      },
    };
  }
  return state;
};

export default debugReducer;
